export const COMPANY_NAME = 'Stormbyte LLC';
export const COMPANY_EMAIL = 'engineering@stormbyte.dev';
export const COMPANY_URL = '/stormbyte';
export const COPYRIGHT_YEAR = 2025;

// App Download Links
export const APP_STORE_URL = 'https://apps.apple.com/us/app/hereabout-app/id6478040527';
export const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.stormbyte.ui';
export const GOOGLE_PLAY_ICON_URL = 'https://static.storm-byte.dev/playstore.png';

// Download Section Content
export const DOWNLOAD_SECTION_TITLE = 'Get Hereabout';
export const DOWNLOAD_SECTION_SUBTITLE = 'Join the community and start exploring your world in a whole new way';
export const APP_STORE_TEXT = {
  small: 'Download on the',
  large: 'App Store',
};
export const GOOGLE_PLAY_TEXT = {
  small: 'Get it on',
  large: 'Google Play',
};
